const testimonials = [
  {
    quote: "The team at Mobile Detail Co. transformed my SUV. They removed stains I thought would never come out! Highly recommend their interior detail package.",
    author: "Sarah W., Minneapolis"
  },
  {
    quote: "I've been using their services for over a year now. Always professional, always on time, and my car always looks amazing when they're done.",
    author: "Michael J., Eden Prairie"
  },
  {
    quote: "They did an amazing job on my ceramic coating. My car looks better than when I bought it new! Worth every penny for the long-term protection.",
    author: "David S., St. Paul"
  },
  {
    quote: "Love the convenience of their mobile service. They came to my office while I was working and did a full detail. My colleagues were impressed!",
    author: "Jessica T., Minnetonka"
  }
];

const TestimonialsSection = () => (
  <section id="testimonials" className="py-16 bg-primary-dark">
    <div className="container mx-auto px-4">
      <h2 className="text-3xl md:text-4xl font-bold text-primary text-center mb-12">
        What Our Customers Say
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
        {testimonials.map((t, i) => (
          <div key={i} className="bg-gray-50 p-6 rounded-lg shadow-sm">
            <p className="italic text-gray-700 mb-4">{t.quote}</p>
            <p className="font-semibold text-primary">{t.author}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default TestimonialsSection; 